/**
 * Utility functions for formatting data
 */

/**
 * Removes quantity prefix from product names
 * Example: "1x Plato del día" -> "Plato del día"
 * Example: "2x Ensalada César" -> "Ensalada César"
 */
export function cleanProductName(productName: string): string {
  // Remove pattern like "1x ", "2x ", "10x ", etc.
  return productName.replace(/^\d+x\s+/, '')
}

/**
 * Format currency to Dominican Peso
 */
export function formatCurrency(amount: number | string): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  return `RD$ ${numAmount.toLocaleString('es-DO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

/**
 * Format date to readable format
 */
export function formatDate(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateObj.toLocaleDateString('es-DO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

/**
 * Format date and time
 */
export function formatDateTime(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateObj.toLocaleString('es-DO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
